import { render, staticRenderFns } from "./AttachmentBatchData.vue?vue&type=template&id=e8d07138"
import script from "./AttachmentBatchData.vue?vue&type=script&lang=js"
export * from "./AttachmentBatchData.vue?vue&type=script&lang=js"
import style0 from "./AttachmentBatchData.vue?vue&type=style&index=0&id=e8d07138&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports